export default (params) => ({
  trigger: {
    name: 'feedback_element.select_feedback',
    params: params,
  },
  config: {
    schema: {
      feedback: {
        enum: [
          'vote_up',
          'vote_down',
        ],
      },
      id_type: {
        enum: [
          'question_id',
          'article_id',
          'review_id',
          'order_id',
          'item_id',
          'message_id',
          'cpc_id',
          'general',
        ],
      },
      unique_id: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'ar',
          'after_order',
          'trade-in',
          'return',
          'energy_insight',
          'other',
          'advice',
          'energy_monthly_report',
        ],
      },
    },
    event: {
      name: 'select_feedback',
      params: {
        qaty_topic: null,
      },
    },
  },
});
